<template>
    <div>
      <workOrderPageAdmin v-if="!$store.getters.cusId" />
      <workOrderPageUser v-else />
    </div>
  </template>
  <script>
  import workOrderPageAdmin from './components/workOrderPageAdmin';
  import workOrderPageUser from './components/workOrderPageUser';
  export default {
    name: 'BusinessOpenWorkorderList',
    components: {
      workOrderPageAdmin,
      workOrderPageUser,
    },
  };
  </script>